(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tm-bundle-pack"] && !Shopify.designMode) return;
  try {
    class TmBundle extends HTMLElement {
      connectedCallback() {
        this.discount = Number(this.dataset.discount) || 0;
        this.checkboxes = Array.from(this.querySelectorAll('[data-bundle-item]'));
        this.totalEl = this.querySelector('[data-bundle-total]');
        this.compareEl = this.querySelector('[data-bundle-compare]');
        this.savingsEl = this.querySelector('[data-bundle-savings]');
        this.addButton = this.querySelector('[data-bundle-add]');
        this.confirmEl = this.querySelector('[data-bundle-confirm]');

        this.checkboxes.forEach((box) => {
          box.addEventListener('change', () => {
            const tile = box.closest('.tm-bundle__tile');
            if (tile) tile.classList.toggle('tm-bundle__tile--off', !box.checked);
            this.#recalculate();
          });
          const tile = box.closest('.tm-bundle__tile');
          if (tile) tile.classList.toggle('tm-bundle__tile--off', !box.checked);
        });

        this.addButton?.addEventListener('click', () => this.#addToCart());

        this.#recalculate();
      }

      #checked() {
        return this.checkboxes.filter((box) => box.checked);
      }

      #formatMoney(amount) {
        return amount.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
      }

      #recalculate() {
        const checked = this.#checked();
        const sum = checked.reduce((total, box) => total + Number(box.dataset.price), 0);
        const applyDiscount = checked.length >= 2;
        const finalTotal = applyDiscount ? sum * (1 - this.discount / 100) : sum;

        if (this.totalEl) this.totalEl.textContent = this.#formatMoney(finalTotal);

        if (applyDiscount) {
          if (this.compareEl) {
            this.compareEl.textContent = this.#formatMoney(sum);
            this.compareEl.hidden = false;
          }
          if (this.savingsEl) {
            this.savingsEl.textContent = `-${this.#formatMoney(sum - finalTotal)}`;
            this.savingsEl.hidden = false;
          }
        } else {
          if (this.compareEl) this.compareEl.hidden = true;
          if (this.savingsEl) this.savingsEl.hidden = true;
        }

        if (this.addButton) this.addButton.disabled = checked.length === 0;
      }

      async #addToCart() {
        const items = this.#checked().map((box) => ({
          id: Number(box.dataset.variantId),
          quantity: 1,
        }));

        if (!items.length) return;

        this.addButton.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) throw new Error('cart add failed');

          if (this.confirmEl) this.confirmEl.hidden = false;
          window.setTimeout(() => {
            window.location.href = '/cart';
          }, 600);
        } catch (error) {
          this.addButton.disabled = false;
        }
      }
    }
    if (!customElements.get('tm-bundle')) customElements.define('tm-bundle', TmBundle);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tm-shipping-timeline"] && !Shopify.designMode) return;
  try {
    class TmShipping extends HTMLElement {
    static months = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

    connectedCallback() {
      const root = this.querySelector('.tm-shipping') || this;

      const holidays = new Set((root.dataset.holidays || '').split(',').map((s) => s.trim()).filter(Boolean));
      const prep = Number(root.dataset.prep) || 0;
      const min = Number(root.dataset.min) || 0;
      const max = Number(root.dataset.max) || 0;

      const toKey = (d) => d.toISOString().slice(0, 10);
      const isBusinessDay = (d) => {
        const day = d.getDay();
        if (day === 0 || day === 6) return false;
        return !holidays.has(toKey(d));
      };
      const addBusinessDays = (start, count) => {
        const d = new Date(start.getTime());
        let remaining = count;
        while (remaining > 0) {
          d.setDate(d.getDate() + 1);
          if (isBusinessDay(d)) remaining -= 1;
        }
        return d;
      };
      const format = (d) => `${d.getDate()} ${TmShipping.months[d.getMonth()]}`;

      const [y, m, day] = (root.dataset.today || '').split('-').map(Number);
      const today = y ? new Date(y, m - 1, day) : new Date();

      const shipDate = addBusinessDays(today, prep);
      const deliverMin = addBusinessDays(shipDate, min);
      const deliverMax = addBusinessDays(shipDate, max);

      const orderEl = root.querySelector('[data-date-order]');
      const shipEl = root.querySelector('[data-date-ship]');
      const deliverEl = root.querySelector('[data-date-deliver]');
      if (orderEl) orderEl.textContent = "Aujourd'hui";
      if (shipEl) shipEl.textContent = format(shipDate);
      if (deliverEl) deliverEl.textContent = `${format(deliverMin)} au ${format(deliverMax)}`;
    }
  }
  if (!customElements.get('tm-shipping')) customElements.define('tm-shipping', TmShipping);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tm-video-stories"] && !Shopify.designMode) return;
  try {
    class TmStoryBubbles extends HTMLElement {
      connectedCallback() {
        this.dialogHost = this.querySelector('dialog-component');
        this.player = this.querySelector('tm-story-player');
        this.querySelectorAll('[data-story-open]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const index = Number(btn.dataset.storyOpen);
            if (this.player) this.player.openAt(index);
            if (this.dialogHost && typeof this.dialogHost.showDialog === 'function') {
              this.dialogHost.showDialog();
            }
          });
        });
      }
    }
    if (!customElements.get('tm-story-bubbles')) customElements.define('tm-story-bubbles', TmStoryBubbles);

    class TmStoryPlayer extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('[data-story-video]'));
        this.bars = Array.from(this.querySelectorAll('[data-bar]'));
        this.fills = Array.from(this.querySelectorAll('[data-bar-fill]'));
        this.stage = this.querySelector('[data-stage]');
        this.playPauseBtn = this.querySelector('[data-play-pause]');
        this.iconPlay = this.querySelector('[data-icon-play]');
        this.muteBtn = this.querySelector('[data-mute-toggle]');
        this.iconMuted = this.querySelector('[data-icon-muted]');
        this.iconUnmuted = this.querySelector('[data-icon-unmuted]');
        this.prevBtn = this.querySelector('[data-story-prev]');
        this.nextBtn = this.querySelector('[data-story-next]');

        this.current = 0;
        this.muted = true;

        this.videos.forEach((video, i) => {
          video.addEventListener('timeupdate', () => this.#updateProgress(i));
          video.addEventListener('ended', () => this.#advance());
          video.addEventListener('click', () => this.#togglePlay());
        });

        this.bars.forEach((bar, i) => {
          const scrub = (event) => {
            const rect = bar.getBoundingClientRect();
            const ratio = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
            const video = this.videos[i];
            if (video && video.duration) video.currentTime = ratio * video.duration;
            if (i !== this.current) this.#show(i);
          };
          bar.addEventListener('pointerdown', (event) => {
            scrub(event);
            const move = (moveEvent) => scrub(moveEvent);
            const up = () => {
              window.removeEventListener('pointermove', move);
              window.removeEventListener('pointerup', up);
            };
            window.addEventListener('pointermove', move);
            window.addEventListener('pointerup', up);
          });
        });

        this.prevBtn?.addEventListener('click', () => this.#show(this.current - 1));
        this.nextBtn?.addEventListener('click', () => this.#show(this.current + 1));
        this.muteBtn?.addEventListener('click', () => this.#toggleMute());

        this.addEventListener('dialog:close', () => this.#reset());
        this.closest('dialog-component')?.addEventListener('dialog:close', () => this.#reset());

        this.#swipeToClose();
      }

      openAt(index) {
        this.#show(index, true);
      }

      #show(index, isOpen) {
        if (index < 0) return;
        if (index >= this.videos.length) {
          this.closest('dialog-component')?.closeDialog?.();
          return;
        }

        this.videos.forEach((video, i) => {
          if (i === index) {
            video.hidden = false;
            video.style.display = 'block';
            if (!video.src && video.dataset.src) video.src = video.dataset.src;
            video.muted = this.muted;
            video.currentTime = isOpen ? 0 : video.currentTime;
            video.play().catch(() => {});
          } else {
            video.style.display = 'none';
            video.pause();
          }
        });

        this.fills.forEach((fill, i) => {
          fill.style.width = i < index ? '100%' : i === index ? '0%' : '0%';
        });

        this.current = index;
        if (this.prevBtn) this.prevBtn.disabled = index === 0;
      }

      #updateProgress(i) {
        if (i !== this.current) return;
        const video = this.videos[i];
        if (!video.duration) return;
        const fill = this.fills[i];
        if (fill) fill.style.width = `${(video.currentTime / video.duration) * 100}%`;
      }

      #advance() {
        this.#show(this.current + 1);
      }

      #togglePlay() {
        const video = this.videos[this.current];
        if (!video) return;
        if (video.paused) {
          video.play();
          if (this.iconPlay) this.iconPlay.hidden = true;
        } else {
          video.pause();
          if (this.iconPlay) this.iconPlay.hidden = false;
        }
      }

      #toggleMute() {
        this.muted = !this.muted;
        this.videos.forEach((video) => (video.muted = this.muted));
        if (this.iconMuted) this.iconMuted.hidden = !this.muted;
        if (this.iconUnmuted) this.iconUnmuted.hidden = this.muted;
      }

      #reset() {
        this.videos.forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });
        this.fills.forEach((fill) => (fill.style.width = '0%'));
      }

      #swipeToClose() {
        let startY = 0;
        this.stage?.addEventListener('pointerdown', (event) => {
          startY = event.clientY;
        });
        this.stage?.addEventListener('pointerup', (event) => {
          if (event.clientY - startY > 80) {
            this.closest('dialog-component')?.closeDialog?.();
          }
        });
      }
    }
    if (!customElements.get('tm-story-player')) customElements.define('tm-story-player', TmStoryPlayer);
  } catch(e) { console.error(e); }
})();

})();
